import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Bell, Users } from "lucide-react";
import { Application } from "@/types/startup";
import { ApplicationCard } from "./ApplicationCard";

interface ApplicationsListProps {
  applications: Application[];
  onSelectApplication: (application: Application) => void;
}

export const ApplicationsList = ({ applications, onSelectApplication }: ApplicationsListProps) => {
  if (!applications.length) return null;

  const pendingApplications = applications.filter(app => app.status === 'pending');
  const acceptedApplications = applications.filter(app => app.status === 'accepted');

  return (
    <div className="space-y-8">
      {pendingApplications.length > 0 && (
        <Card className="bg-flux-black/50 border-flux-cyan/20">
          <CardHeader>
            <CardTitle className="flex items-center text-flux-cyan">
              <Bell className="w-5 h-5 mr-2" />
              Recent Applications
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {pendingApplications.map((application) => (
                <ApplicationCard
                  key={application.id}
                  application={application}
                  onClick={() => onSelectApplication(application)}
                />
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {acceptedApplications.length > 0 && (
        <Card className="bg-flux-black/50 border-flux-cyan/20">
          <CardHeader>
            <CardTitle className="flex items-center text-flux-cyan">
              <Users className="w-5 h-5 mr-2" />
              Team Members
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {acceptedApplications.map((application) => (
                <ApplicationCard
                  key={application.id}
                  application={application}
                  onClick={() => onSelectApplication(application)}
                />
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};